interface DropdownOption {
  value: string;
  label: string;
}

const capitalizeFirstLetter = (text: string): string => {
  if (text.length === 0) return text;
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
};

const importAll = (requireContext: __WebpackModuleApi.RequireContext): DropdownOption[] => {
  let modules: DropdownOption[] = [];
  requireContext.keys().map((key: string) => {
    const fileNameWithExtension = key.replace(/^.*[\\/]/, "");
    const fileNameWithoutExtension = fileNameWithExtension.replace(/\.[^/.]+$/, ""); // Remove file extension
    const fileName = fileNameWithoutExtension.replace(/[_-]/g, " "); // Replace underscores and dashes with spaces
    const capitalizedFileName = capitalizeFirstLetter(fileName);
    modules.push({ value: fileNameWithExtension, label: capitalizedFileName });
  });
  modules = Array.from(
    new Set(modules.map((module: DropdownOption) => JSON.stringify(module))),
  ).map((str: string) => JSON.parse(str, (key, value) => value));
  return modules;
};

export const getSoundsArray = () => {
  return importAll(require.context("assets/sounds", false, /\.(mp3|wav)$/));
};
